'use strict';
module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/is-pure.js
// module id = 137
// module chunks = 0